import {
  ChangeDetectionStrategy,
  Component,
  inject,
  INJECTOR,
  OnInit,
} from '@angular/core';
import { handleRequestError, title } from '@softline/application';
import { RouterModule } from '@angular/router';
import { MilchartikelService } from '../services/milchartikel.service';

@Component({
  selector: 'soft-rohstoffbereitstellung',
  imports: [RouterModule],
  templateUrl: './rohstoffbereitstellung.component.html',
  styleUrls: ['./rohstoffbereitstellung.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class RohstoffbereitstellungComponent implements OnInit {
  private readonly milchartikelService = inject(MilchartikelService);

  readonly #injector = inject(INJECTOR);

  constructor() {
    title('Rohstoffbereitstellung');
  }

  ngOnInit(): void {
    try {
      this.milchartikelService.reload();
    } catch (e) {
      handleRequestError(e, this.#injector, { show: true });
    }
  }
}
